import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar, CalendarCheck, CalendarX, Users } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const CalendriersStatsCards = ({ stats, statsLoading }) => {
  const { t } = useTranslation();

  if (statsLoading) {
    return (
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 mb-6">
        {[...Array(4)].map((_, i) => (
          <Card key={i}>
            <CardHeader className="animate-pulse">
              <div className="h-4 bg-muted rounded w-3/4"></div>
            </CardHeader>
            <CardContent>
              <div className="h-8 bg-muted rounded w-1/2"></div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  if (!stats) return null;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 mb-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">{t("holidayCalendarComponents.stats.total")}</CardTitle>
          <Calendar className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.total_calendars}</div>
          <p className="text-xs text-muted-foreground">{t("holidayCalendarComponents.stats.totalDesc")}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">{t("holidayCalendarComponents.stats.approved")}</CardTitle>
          <CalendarCheck className="h-4 w-4 text-green-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.calendars_by_status?.APPROVED || 0}</div>
          <p className="text-xs text-muted-foreground">{t("holidayCalendarComponents.stats.approvedDesc")}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">{t("holidayCalendarComponents.stats.drafts")}</CardTitle>
          <CalendarX className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.calendars_by_status?.DRAFT || 0}</div>
          <p className="text-xs text-muted-foreground">{t("holidayCalendarComponents.stats.draftsDesc")}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">{t("holidayCalendarComponents.stats.assignedEmployees")}</CardTitle>
          <Users className="h-4 w-4 text-blue-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.total_employees_assigned}</div>
          <p className="text-xs text-muted-foreground">
            {t("holidayCalendarComponents.stats.withoutCalendar", { count: stats.employees_without_calendar })}
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default CalendriersStatsCards;
